<template>
  <div>
    <div class="container">
      <div class="row justify-content-center p-5">
        <div class="col-xl-10 col-lg-12 col-md-9 p-5">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <div class="row p-5 m-5" v-if="error" style="height:400px">
                <div class="col-md-12 text-center">
                  <sweetalert-icon :icon="errorType" />
                </div>
                <div class="col-md-12 text-center">
                  <h3 class="text-center">{{ errormessage }}</h3>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
                    </div>
                    <form class="user" @submit.prevent="loginAction">
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control form-control-user"
                          v-model="loginUser.email"
                          aria-describedby="emailHelp"
                          placeholder="Enter Email Address..."
                        />
                      </div>
                      <div class="form-group">
                        <input
                          type="password"
                          class="form-control form-control-user"
                          v-model="loginUser.password"
                          placeholder="Password"
                        />
                      </div>
                      <button
                        class="btn btn-primary btn-user btn-block"
                        type="submit"
                      >
                        Login
                      </button>
                      <hr />
                    </form>
                    <hr />
                    <div class="text-center">
                      <router-link to="/resetpassword" class="small">
                        Forgot Password?</router-link
                      >
                    </div>
                    <div class="text-center">
                      <router-link to="/vendor/register" class="small">
                        Create an Vendor Account!
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// img = require('.../assets/')
import { mapGetters } from "vuex";
import { login } from "@/modules/auth";
import constants from "@/modules/constants";
import { CheckUserAccess } from "@/modules/database";
import router from "@/modules/router";
export default {
  data() {
    return {
      error: false,
      errorType: "success",
      errormessage: "",
      loginUser: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.check_login();
  },
  methods: {
    check_login() {
      if (this.user !== null) {
        CheckUserAccess()
          .then(data => {
            let type = data.type;
            let access = data.permission;
            if (type == "admin" && access == "admin") {
              this.redirect_to_admin();
            }
            if (type == "vendor") {
              if (access == "admin") {
                this.redirect_to_vendor();
              }
              if (access == "packer") {
                this.redirect_to_login("/vendor/packer");
              }
              if (access == "delivery") {
                this.redirect_to_login("/delivery/order");
              }
            }
          })
          .catch(() => {
            this.error = true;
            this.errorType = "warning";
            this.errormessage = `Welcome Back, Sorry you are not authorized to login`;
            setTimeout(() => {
              this.error = false;
              this.$root.logout();
              this.redirect_to_login("/");
            }, 3000);
          });
      }
    },
    loginAction() {
      console.log();
      let email = this.loginUser.email;
      let password = this.loginUser.password;
      if (!(email && password)) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (email.trim().length === 0 || password.trim().length === 0) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      login(email, password)
        .then(user => {
          this.navigateAfterLogin = true;
          this.navigateTimeout = setTimeout(() => {
            this.navigateAfterLogin = false;
          }, 10000);
          CheckUserAccess()
            .then(data => {
              let type = data.type;
              let access = data.permission;
              console.log(access);
              console.log(type);
              this.error = true;
              this.errorType = "success";
              this.errormessage = `Welcome Back,  ${user.displayName.split(
                " "
              )[0] || user.displayName}`;
              this.$root.toast(
                "Welcome back, " +
                  (user.displayName.split(" ")[0] || user.displayName) +
                  "!"
              );
              setTimeout(() => {
                if (type == "admin" && access == "admin") {
                  this.redirect_to_admin();
                }
                if (type == "vendor") {
                  if (access == "admin") {
                    this.redirect_to_vendor();
                  }
                  if (access == "packer") {
                    this.redirect_to_login("/vendor/packer");
                  }
                  if (access == "delivery") {
                    this.redirect_to_login("/delivery/order");
                  }
                }
              }, 3000);
            })
            .catch(err => {
              console.log(err);
              this.error = true;
              this.errorType = "warning";
              this.errormessage = `Welcome Back,  ${user.displayName.split(
                " "
              )[0] ||
                user.displayName} Sorry your Account not Verify Contact to Admin`;
              setTimeout(() => {
                this.error = false;
                this.redirect_to_login("/vendor");
                this.$root.logout();
              }, 3000);
            });
        })
        .catch(error => {
          this.error = true;
          this.errorType = "error";
          this.errormessage = constants.errors["auth/wrong-password"];
          console.log(error);
          setTimeout(() => {
            this.error = false;
            this.redirect_to_login("/vendor");
          }, 3000);
        })
        .finally(() => {
          this.loginUser.email = "";
          this.loginUser.password = "";
        });
    },
    redirect_to_admin() {
      router.push("/admin/dashboard");
    },
    redirect_to_vendor() {
      router.push("/vendor/dashboard");
    },
    redirect_to_home() {
      router.push("/");
    },
    redirect_to_login(url) {
      router.push(url);
    }
  },
  watch: {
    // user() {
    //   if()
    //   this.check_login();
    // }
  }
};
</script>

<style scoped>
/* .bg-login-image {
  background-image: url("/assets/login.png");
} */
</style>
